import Vue from 'vue'
import VueRouter from 'vue-router'
import Auth from '../views/Auth.vue'

Vue.use(VueRouter)

const webTitle = ' Admin Coding IT Studio'

const routes = [
  {
    path: '/',
    component: () => import('@/views/Cms.vue'),
    redirect: {
      name: 'Website'
    },
    children: [
      {
        path: 'website',
        name: 'Website',
        component: () => import('@/components/Website.vue'),
        meta: { title: `${'網站資訊' + ' | '}${webTitle}` }
      },
      {
        path: 'contactInfo',
        name: 'ContactInfo',
        component: () => import('@/components/ContactInfo.vue'),
        meta: { title: `${'聯絡資訊' + ' | '}${webTitle}` }
      },
      {
        path: 'navbarInfo',
        name: 'NavbarInfo',
        component: () => import('@/components/NavbarInfo.vue'),
        meta: { title: `${'導覽列' + ' | '}${webTitle}` }
      },
      {
        path: 'homeInfo',
        name: 'HomeInfo',
        component: () => import('@/components/HomeInfo.vue'),
        meta: { title: `${'首頁' + ' | '}${webTitle}` }
      },
      {
        path: 'about',
        name: 'About',
        component: () => import('@/components/About.vue'),
        meta: { title: `${'關於我們' + ' | '}${webTitle}` }
      },
      {
        path: 'qa',
        name: 'Qa',
        component: () => import('@/components/Qa.vue'),
        meta: { title: `${'常見問答' + ' | '}${webTitle}` }
      },
      {
        path: 'policy',
        name: 'Policy',
        component: () => import('@/components/Policy.vue'),
        meta: { title: `${'關於法律與隱私' + ' | '}${webTitle}` }
      },
      {
        path: 'notice',
        name: 'Notice',
        component: () => import('@/components/Notice.vue'),
        meta: { title: `${'其他設定' + ' | '}${webTitle}` }
      },
      {
        path: 'product-category',
        name: 'ProductCategory',
        component: () => import('@/components/ProductCategory.vue'),
        meta: { title: `${'產品分類' + ' | '}${webTitle}` }
      },
      {
        path: 'product-category/:id',
        name: 'ProductCategorySub',
        component: () => import('@/components/ProductCategorySub.vue'),
        meta: { title: `${'產品子分類' + ' | '}${webTitle}` }
      },
      {
        path: 'product',
        name: 'Product',
        component: () => import('@/components/Product.vue'),
        meta: { title: `${'產品列表' + ' | '}${webTitle}` }
      },
      {
        path: 'order',
        name: 'Order',
        component: () => import('@/components/Order.vue'),
        meta: { title: `${'訂單列表' + ' | '}${webTitle}` }
      },
      {
        path: 'order/:id',
        name: 'OrderDetails',
        component: () => import('@/components/OrderDetails.vue'),
        meta: { title: `${'訂單詳細資料' + ' | '}${webTitle}` }
      },
      {
        path: 'report',
        name: 'Report',
        component: () => import('@/components/Report.vue'),
        meta: { title: `${'報表匯出' + ' | '}${webTitle}` }
      },
      {
        path: 'travel-category',
        name: 'TravelCategory',
        component: () => import('@/components/TravelCategory.vue'),
        meta: { title: `${'行程分類' + ' | '}${webTitle}` }
      },
      {
        path: 'travel-category/:id',
        name: 'TravelCategorySub',
        component: () => import('@/components/TravelCategorySub.vue'),
        meta: { title: `${'行程子分類' + ' | '}${webTitle}` }
      },
      {
        path: 'travel',
        name: 'Travel',
        component: () => import('@/components/Travel.vue'),
        meta: { title: `${'行程列表' + ' | '}${webTitle}` }
      },
      {
        path: 'article-category',
        name: 'ArticleCategory',
        component: () => import('@/components/ArticleCategory.vue'),
        meta: { title: `${'文章分類' + ' | '}${webTitle}` }
      },
      {
        path: 'article',
        name: 'Article',
        component: () => import('@/components/Article.vue'),
        meta: { title: `${'文章列表' + ' | '}${webTitle}` }
      },
      {
        path: 'inquiry-itinerary',
        name: 'InquiryItinerary',
        component: () => import('@/components/InquiryItinerary.vue'),
        meta: { title: `${'旅遊行程諮詢單' + ' | '}${webTitle}` }
      },
      {
        path: 'inquiry-store',
        name: 'InquiryStore',
        component: () => import('@/components/InquiryStore.vue'),
        meta: { title: `${'門市參觀諮詢單' + ' | '}${webTitle}` }
      },
      {
        path: 'inquiry-product',
        name: 'InquiryProduct',
        component: () => import('@/components/InquiryProduct.vue'),
        meta: { title: `${'訂製商品諮詢單' + ' | '}${webTitle}` }
      },
      {
        path: 'store',
        name: 'Store',
        component: () => import('@/components/Store.vue'),
        meta: { title: `${'門市管理' + ' | '}${webTitle}` }
      },
      {
        path: 'user',
        name: 'User',
        component: () => import('@/components/User.vue'),
        meta: { title: `${'使用者管理' + ' | '}${webTitle}` }
      }
    ]
  },
  {
    path: '/reset-password',
    component: Auth,
    children: [
      {
        path: '/',
        name: 'ResetPassword',
        component: () => import('@/components/auth/ChangePassword.vue'),
        meta: { title: `${'重置密碼' + ' | '}${webTitle}` }
      }
    ]
  },
  {
    path: '/auth',
    component: Auth,
    children: [
      {
        path: 'login',
        name: 'Login',
        component: () => import('@/components/auth/Login.vue'),
        meta: { title: `登入 | ${webTitle}` }
      },
      {
        path: 'forgot-password',
        name: 'ForgotPassword',
        component: () => import('@/components/auth/ForgotPassword.vue'),
        meta: { title: `忘記密碼 | ${webTitle}` }
      }
    ]
  },
  {
    path: '*',
    name: 'Error',
    component: () => import('@/views/ErrorPage.vue'),
    meta: { title: `${'404 Error' + ' | '}${webTitle}` }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  linkActiveClass: 'active',
  linkExactActiveClass: 'active'
})

router.beforeEach((to, from, next) => {
  const isAuthenticated = localStorage.getItem('codingIt_admin_token')
  window.document.title = to.meta.title
  if (to.name === 'ResetPassword' || to.name === 'ForgotPassword') {
    next()
  } else if (to.name !== 'Login' && !isAuthenticated) {
    next({ name: 'Login' })
  } else if (to.name === 'Login' && isAuthenticated) {
    next({ name: 'Website' })
  } else {
    next()
  }
})
router.afterEach(() => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
})
export default router
